import { css } from '@emotion/react';

export const root = css`
  display: flex;
  min-width: 39.3rem;
  max-width: 42.6rem;
  padding: 1.8rem 1.3rem;
  border-left: 0.4rem solid;
  border-radius: 0.4rem;
  &[data-status='success'] {
    background-color: var(--color-primary-light);
    border-color: var(--color-primary-default);
  }
  &[data-status='warning'] {
    background-color: var(--color-tertiary-light);
    border-color: var(--color-tertiary-default);
  }
  &[data-status='error'] {
    background-color: var(--color-secondary-light);
    border-color: var(--color-secondary-default);
  }
`;

export const icon = css`
  width: 1.9rem;
  flex-shrink: 0;
  &[data-status='success'] {
    color: var(--color-primary-default);
  }
  &[data-status='warning'] {
    color: var(--color-tertiary-default);
  }
  &[data-status='error'] {
    color: var(--color-secondary-default);
  }
  > svg {
    vertical-align: middle;
  }
`;

export const content = css`
  flex: 1;
  padding-left: 0.8rem;
`;

export const title = css`
  padding-top: 0.2rem;
  margin-bottom: 0.1rem;
  font-size: 1.6rem;
  font-weight: 700;
`;

export const message = css`
  padding-top: 0.3rem;
  font-size: 1.4rem;
`;
